import { useTranslation } from "react-i18next";

import { VoterCardProps } from "../types";
import CheckIcon from "../CheckIcon";
import {
    CardButton,
    Detail,
    Identity,
    Name,
    StatusBadge,
} from "./VoterCard.styles";

const BADGE_CHECK_SIZE = 14;
const BADGE_CHECK_STROKE_WIDTH = 3.5;

// Card opening the vote of one voter, the holder or a proxy. The vote status is written in a
// badge, not given by the green color alone (RGAA 3.1).
const VoterCard = ({
    displayName,
    handleClick,
    hasVoted,
    voterWeight,
}: VoterCardProps) => {
    const { t } = useTranslation();

    const isAllowedToVote = 0 !== voterWeight;

    function renderDetail() {
        if (!isAllowedToVote) {
            return <Detail>{t("noAllowedToVote")}</Detail>;
        }

        if (voterWeight > 1) {
            return (
                <Detail>
                    {t("numberOfVote")} {voterWeight}
                </Detail>
            );
        }

        return null;
    }

    const statusLabel = hasVoted
        ? t(`sentSucceded.${window.env.REACT_APP_THEME}`)
        : t("waitingForVote");
    const checkIcon = hasVoted ? (
        <CheckIcon
            size={BADGE_CHECK_SIZE}
            strokeWidth={BADGE_CHECK_STROKE_WIDTH}
        />
    ) : null;
    const statusBadge = isAllowedToVote ? (
        <StatusBadge $hasVoted={hasVoted}>
            {checkIcon}
            <span>{statusLabel}</span>
        </StatusBadge>
    ) : null;

    return (
        <CardButton
            type="button"
            data-testid={`voter-${displayName}`}
            onClick={handleClick}
            disabled={!isAllowedToVote}
            $hasVoted={hasVoted}
        >
            <Identity>
                <Name>{displayName}</Name>
                {renderDetail()}
            </Identity>
            {statusBadge}
        </CardButton>
    );
};

export default VoterCard;
